import { render, staticRenderFns } from "./SeguimentoCreate.vue?vue&type=template&id=128c7b05&"
import script from "./SeguimentoCreate.vue?vue&type=script&lang=js&"
export * from "./SeguimentoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports